import { DEFAULT_DATE_FORMAT_FNS } from '@schooly/api';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { addDays, format, parse, startOfISOWeek } from 'date-fns';
import { useCallback, useMemo, useState } from 'react';

import { WeekOption } from '../common/getWeeksWithStudents';

export type UseAttendanceWeekDropdownResult = {
  weekOptions: WeekOption[];
  selectedOption: WeekOption | undefined;
  onSelectWeek: (option: WeekOption) => void;
  weekDates: string[];
};

export const useAttendanceWeekDropdown = (
  weekOptions: WeekOption[],
): UseAttendanceWeekDropdownResult => {
  const currentWeekId = format(startOfISOWeek(newDateTimezoneOffset()), DEFAULT_DATE_FORMAT_FNS);

  const defaultId =
    weekOptions.find((o) => o.id === currentWeekId)?.id ??
    weekOptions[weekOptions.length - 1]?.id ??
    '';

  const [selectedId, setSelectedId] = useState<string | null>(null);
  const effectiveId = selectedId ?? defaultId;

  const selectedOption = weekOptions.find((o) => o.id === effectiveId);

  const onSelectWeek = useCallback((option: WeekOption) => {
    setSelectedId(option.id);
  }, []);

  const weekDates = useMemo(() => {
    if (!effectiveId) return [];
    const start = parse(effectiveId, DEFAULT_DATE_FORMAT_FNS, newDateTimezoneOffset());
    return Array.from({ length: 7 }, (_, i) => format(addDays(start, i), DEFAULT_DATE_FORMAT_FNS));
  }, [effectiveId]);

  return { weekOptions, selectedOption, onSelectWeek, weekDates };
};
